<div class="field-dialog__content__scroll p-24" fusePerfectScrollbar>
  <div
    *ngIf="!data.maintenance.attachments || !data.maintenance.attachments.length"
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <p fxFlex="100" fxLayout="row">
      <mat-icon class="no-results-icon">attach_file</mat-icon>
    </p>
    <div fxFlex="100" fxLayout="row">
      <span class="h3">Nenhum anexo</span>
    </div>
  </div>

  <div *ngIf="requestAttachments && requestAttachments.length">
    <div class="mb-16" fxLayout="row" fxLayoutAlign="start">
      <mat-icon class="mr-8">attachment</mat-icon>
      <span>{{ 'MAINTENANCES.TABS.ATTACHMENTS.OPEN_ATTACHMENTS' | translate }}</span>
    </div>

    <div class="attachment w-100-p" *ngFor="let attachment of requestAttachments">
      <attachment [attachment]="attachment"></attachment>
    </div>
  </div>

  <div
    *ngIf="integrationAttachments && integrationAttachments?.length"
    [class.mt-16]="integrationAttachments.length && integrationAttachments.length"
  >
    <div class="mb-16" fxLayout="row" fxLayoutAlign="start">
      <mat-icon class="mr-8">attachment</mat-icon>
      <span>{{ 'MAINTENANCES.TABS.ATTACHMENTS.MAINTENANCE_ATTACHMENTS' | translate }}</span>
    </div>

    <div class="attachment w-100-p" *ngFor="let attachment of integrationAttachments">
      <attachment [attachment]="attachment"></attachment>
    </div>
  </div>
</div>
